import { useState } from 'react'
import styled from 'styled-components'
import { getUserThingConversations } from '../../utils/services/chatFunctions'
import { useQuery } from '@tanstack/react-query'
import { sellThing } from '../../utils/services/fetchThing'
import { useNavigate } from 'react-router-dom' // Importer useNavigate

const StyledSoldContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(158, 18, 18, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
`
const StyledSoldBox = styled.div`
    width: 80%;
    height: 80%;
    background-color: #5c83ab;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
`

const StyledSoldButton = styled.button`
    width: 100%;
    padding: 10px;
    background-color: #a21111;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
        background-color: #8a0e0e;
    }
`
const StyledReturnButton = styled.button`
    width: 100%;
    padding: 10px;
    background-color: #ffffff;
    color: black;
    border: none;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
        background-color: #a3a3a3;
    }
`

const DropdownMenu = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    border: 1px solid #ccc;
    position: absolute;
    background-color: white;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    z-index: 999;
`

const DropdownItem = styled.li`
    padding: 10px;
    cursor: pointer;

    &:hover {
        background-color: #f1f1f1;
    }
`

const SellProduct = ({ setIsSoldVisible, thingInfo }) => {
    const navigate = useNavigate() // Initialiser le hook useNavigate

    const [isOpen, setIsOpen] = useState(false) // Gère l'ouverture/fermeture du menu
    const [selectedBuyer, setSelectedBuyer] = useState('') // L'ID de l'acheteur sélectionné

    // get the database of the stuff categories
    const {
        data: buyersList,
        isLoading: isLoadingBuyersList,
        isError: isErrorBuyersList,
    } = useQuery({
        queryKey: ['buyersList', thingInfo._id],
        queryFn: () => getUserThingConversations(thingInfo._id),
        staleTime: 60 * 60 * 1000,
        retry: 0,
        onError: (err) => {
            console.error('Error fetching stuff categories:', err)
        },
    })

    if (isLoadingBuyersList) {
        return <div>Chargement de la liste des acheteurs...</div>
    }

    if (isErrorBuyersList) {
        return <div>Erreur lors du chargement de la liste des acheteurs...</div>
    }

    const toggleDropdown = () => setIsOpen(!isOpen) // Alterne l'état du menu

    const handleSelect = (buyer) => {
        setSelectedBuyer(buyer) // Met à jour la valeur sélectionnée
        setIsOpen(false) // Ferme le menu après la sélection
    }

    const handleClickClose = () => {
        setIsSoldVisible(false) // Ferme la fenêtre de vente
    }

    const handleSoldThing = async () => {
        if (!selectedBuyer) {
            alert('Veuillez sélectionner un acheteur')
            return
        }

        try {
            await sellThing(thingInfo._id, selectedBuyer._id)
            window.location.replace('/Dashboard')
        } catch (error) {
            console.error(
                'Erreur lors de la requête:',
                error.response ? error.response.data : error.message
            )
        }
    }

    return (
        <StyledSoldContainer>
            <StyledSoldBox>
                <h2>Objet vendu ?</h2>
                <div>A qui avez-vous vendu ?</div>

                {/* Dropdown Toggle Button */}
                <button className="dropdown-toggle" onClick={toggleDropdown}>
                    {selectedBuyer.pseudo
                        ? selectedBuyer.pseudo
                        : 'Sélectionnez un acheteur'}
                </button>
                {selectedBuyer && (
                    <div
                        onClick={() =>
                            navigate(`/PublicProfile/${selectedBuyer._id}`)
                        }
                    >
                        Voir le profile
                    </div>
                )}

                {/* Dropdown List */}
                {buyersList && isOpen && (
                    <DropdownMenu>
                        {buyersList.map((buyer) => (
                            <DropdownItem
                                key={buyer._id}
                                onClick={() => handleSelect(buyer)}
                            >
                                {buyer.pseudo}
                            </DropdownItem>
                        ))}
                    </DropdownMenu>
                )}

                {/* Annuler Button */}
                <StyledReturnButton onClick={handleClickClose}>
                    Annuler
                </StyledReturnButton>

                {/* Vendu Button */}
                <StyledSoldButton onClick={handleSoldThing}>
                    Vendu
                </StyledSoldButton>
            </StyledSoldBox>
        </StyledSoldContainer>
    )
}

export default SellProduct
